import * as React from 'react';
import './styles-options.scss';
import { onLoad } from './init';
import { OptionsPage } from './components/optionsPage/OptionsPage';

window.onload = () => onLoad(<OptionsPage />);
